import React from "react";

// ui importing
import ParrentQuestionUI from "../../UI/parrentQuestionUI/_index";

const ParrentQuestionPage = () => {

  // TODO: check usename exist
  return (
    <ParrentQuestionUI />
  )
}

export default ParrentQuestionPage;
